// Youtube, Fb...
const VIDEO = 'video';
// Photo, Frame...
const IMAGE = 'image';

export default { VIDEO, IMAGE };
